import { PrivilegeChecker, ApiCall } from 'omni-common-ui';
import is from 'is_js';
import { buildProgressTestViewLinkUrl } from 'data/ProgressTests/ViewLink/actions';
import { getProgressTestPlanFromIndex, isMarkable, checkIsUnitQuiz } from 'data/ProgressTestsPlan/accessors';
import Privileges from 'domain/Privileges';
import ProgressTestCourseView from './component';
import { actions as groupActions } from 'containers/Group';

const PT_VIEWER_NAME = 'Assessment Viewer';

export default ({ getState }) => ({
  path: ':progressTestIndex/course(/:mode)',
  view: 'course',
  component: ProgressTestCourseView,
  sessionNavConfig: {
    setModeOnNavigate: '',
  },
  canAccess: (props) => {
    if (! ProgressTestCourseView.isInMarkingRoute(props)) {
      return true;
    }
    return PrivilegeChecker.hasPrivilege(getState(), Privileges.ProgressTest.Edit);
  },
  breadcrumbLabels: ({ params }) => {
    if (params.mode === 'edit') return 'Edit';
    return [];
  },
  actionButtons: {
    default: {
      Mark: {
        route: './edit',
        visibleWhen: ({ location, params }) => {
          if (groupActions.isHFV4CourseTypeGroup(getState(), params.groupId)) {
            return false;
          }
          const isUnitQuiz = checkIsUnitQuiz(location.pathname);
          return PrivilegeChecker.hasPrivilege(getState(), Privileges.ProgressTest.Edit) &&
            isMarkable(getState(), params.groupId,
              Number.parseInt(params.progressTestIndex, 10), isUnitQuiz);
        },
        isPrimary: true,
      },
      [PT_VIEWER_NAME]: {
        label: ({ location: { pathname }, params: { groupId, progressTestIndex } }) => {
          const call =
            getProgressTestViewLinkApiCall(getState(), groupId, progressTestIndex, pathname);
          if (! is.existy(call)) {
            return '';
          }
          return ApiCall.State.hasFailed(call) ?
              `${PT_VIEWER_NAME} is not available now` :
              PT_VIEWER_NAME;
        },
        newTab: true,
        linkHref: ({ location: { pathname }, params: { groupId, progressTestIndex } }) => {
          const progressTestLink =
            getProgressTestViewLinkResultViaIndex(getState(), groupId, progressTestIndex, pathname);
          return progressTestLink && progressTestLink.url;
        },
        visibleWhen: ({ location: { pathname }, params: { groupId, progressTestIndex } }) => {
          const state = getState();

          if (groupActions.isSSCourseTypeGroup(state, groupId) ||
            groupActions.isNotTBv3Group(state, groupId)) {
            return false;
          }

          const progressTestLink =
              getProgressTestViewLinkResultViaIndex(state, groupId, progressTestIndex, pathname);
          if (progressTestLink &&
            (progressTestLink.isHaveOnlineCourseKey === false ||
              progressTestLink.isEnabledPTViewer === false)) {
            return false;
          }
          const call = getProgressTestViewLinkApiCall(state, groupId, progressTestIndex, pathname);
          return is.existy(call) &&
            ! ApiCall.State.shouldPerform(call) &&
            ! ApiCall.State.isLoading(call);
        },
        disableWhen: ({ location: { pathname }, params: { groupId, progressTestIndex } }) => {
          const state = getState();
          const progressTestLink =
              getProgressTestViewLinkResultViaIndex(state, groupId, progressTestIndex, pathname);
          const call = getProgressTestViewLinkApiCall(state, groupId, progressTestIndex, pathname);
          try {
            return ApiCall.State.hasFailed(call) || progressTestLink.url.length === 0;
          } catch (e) {
            return true;
          }
        },
      },
    },
    edit: {
      Save: {
        isPrimary: true,
        route: '../save',
      },
      Discard: {
        route: '../discard',
      },
    },
  },
});

function getProgressTestViewLinkResultViaId(state, progressTestId) {
  return state.get('rootReducer').get('progressTestViewLink') &&
    state.get('rootReducer').get('progressTestViewLink').get(`${progressTestId}`);
}

function getProgressTestViewLinkResultViaIndex(state, groupId, progressTestIndex, pathname) {
  const isUnitQuiz = checkIsUnitQuiz(pathname);
  const progressTestId =
    getProgressTestPlanFromIndex(state, groupId, progressTestIndex, isUnitQuiz) &&
    getProgressTestPlanFromIndex(state, groupId, progressTestIndex, isUnitQuiz).id;
  if (! is.existy(progressTestId)) {
    return undefined;
  }
  return getProgressTestViewLinkResultViaId(state, progressTestId);
}

function getProgressTestViewLinkApiCall(state, groupId, progressTestIndex, pathname) {
  const isUnitQuiz = checkIsUnitQuiz(pathname);
  const progressTestId =
    getProgressTestPlanFromIndex(state, groupId, progressTestIndex, isUnitQuiz) &&
    getProgressTestPlanFromIndex(state, groupId, progressTestIndex, isUnitQuiz).id;
  if (is.existy(progressTestId)) {
    const call = ApiCall.find(state, {
      method: 'GET',
      url: buildProgressTestViewLinkUrl(progressTestId),
    });
    return call;
  }
}



// WEBPACK FOOTER //
// ./containers/Group/ProgressTest/ProgressTestCourseView/routes.js